"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDatasetNotFoundMessage = exports.buildElementNotFoundMessage = exports.parseDatasetValue = exports.debounce = exports.getCsrfToken = exports.makeFunctionUrlTo = void 0;
function makeFunctionUrlTo(baseUrl) {
    return function (path) {
        return baseUrl + path;
    };
}
exports.makeFunctionUrlTo = makeFunctionUrlTo;
/**
 * Get the csrf-token from the meta meta element
 */
function getCsrfToken() {
    var metaCsrfToken = document.querySelector('meta[name=csrf-token]');
    if (metaCsrfToken === null) {
        throw new Error('Meta csrf-token element not found.');
    }
    if (!metaCsrfToken.content) {
        throw new Error('Csrf-token not found: meta csrf-token content is empty.');
    }
    return metaCsrfToken.content;
}
exports.getCsrfToken = getCsrfToken;
/**
 * Reduce the rate at which a function is called.
 *
 * @see https://dillionmegida.com/p/debouncing-in-javascript/
 * @see https://gist.github.com/ca0v/73a31f57b397606c9813472f7493a940
 */
function debounce(callback, delay) {
    if (delay === void 0) { delay = 1000; }
    var timerId;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timerId);
        timerId = setTimeout(function () {
            callback.apply(void 0, args);
        }, delay);
    };
}
exports.debounce = debounce;
function parseDatasetValue(value, datasetName) {
    if (!value) {
        throw new Error("Dataset \"data-".concat(datasetName, "\" is empty"));
    }
    return value;
}
exports.parseDatasetValue = parseDatasetValue;
function buildElementNotFoundMessage(selector) {
    return "Element not found, selector: ".concat(selector);
}
exports.buildElementNotFoundMessage = buildElementNotFoundMessage;
function buildDatasetNotFoundMessage(dataAttributeName, datasetName) {
    return 'Dataset not found. '
        + (datasetName ? "\"".concat(datasetName, "\" (\"").concat(dataAttributeName, "\")") : "\"".concat(dataAttributeName, "\""));
}
exports.buildDatasetNotFoundMessage = buildDatasetNotFoundMessage;
